import CMSPage from "@/components/CMSPage";
import { Star } from "lucide-react";

export default function TestimonialsPage() {
  return (
    <CMSPage
      pageId="testimonials"
      defaultTitle="What Our Customers Say"
      defaultDescription="Read reviews and testimonials from homeowners we've helped buy, sell, and move. Discover why thousands of customers trust Sell Local Homes."
      icon={Star}
    />
  );
}
